import axios from "axios";
import config from "./serviceConfig";

const BASE_URL = config.BASE_URL
const ADMIN_API = BASE_URL + 'api/admin/'

const sendAdminLoginReq = async (uname, pass) => await axios.post(ADMIN_API, {uname, pass})

export { sendAdminLoginReq }